var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "multiple-widgets" },
    _vm._l(_vm.items, function (item) {
      return _c("DefaultWidget", {
        key: item.name,
        attrs: {
          disabled: item.disabled,
          "data-name": item.name,
          name: item.displayName,
          icon: item.icon,
        },
        on: {
          click: function ($event) {
            return _vm.runItemAction(item, $event)
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }